import { RootState } from '@Store/index';
import { createSelector } from '@reduxjs/toolkit';

const activeSideMenu = (state: RootState) => state.common.activeSideMenu;

const getIsToggleSideMenu = createSelector(
  activeSideMenu,
  ({ isToggleSideMenu }) => isToggleSideMenu
);

export { getIsToggleSideMenu };
